module.exports = __webpack_public_path__ + "static/media/FaturaBackground.b4ff8492.png";